module.exports = __webpack_public_path__ + "static/media/apple-certificate.44ab9499.bin";